/**
 * Minimal Markdown renderer — purposefully small and safe.
 *
 * Handles paragraphs, line breaks, **bold**, *italic*, `code`, and
 * [link](https://...) — enough for evidence block bodies. Anything more
 * than that should be authored as plain prose or split across multiple
 * blocks.
 *
 * We escape HTML entities before applying inline replacements so admin
 * content cannot inject script tags.
 */
function escapeHtml(s) {
    return String(s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}

function inlineFormat(s) {
    // Links — restricted to http/https.
    s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noreferrer" class="text-[#56CCF2] hover:text-white underline">$1</a>');
    // Bold
    s = s.replace(/\*\*([^*]+)\*\*/g, '<strong class="text-white">$1</strong>');
    // Italic
    s = s.replace(/(^|[^*])\*([^*]+)\*/g, '$1<em>$2</em>');
    // Inline code
    s = s.replace(/`([^`]+)`/g, '<code class="bg-[#0B1220] px-1 py-0.5 rounded text-[#56CCF2] font-mono text-[12px]">$1</code>');
    return s;
}

export function renderMarkdown(md) {
    if (!md) return "";
    const escaped = escapeHtml(md);
    // Split into paragraphs on blank lines; convert single line breaks to <br>.
    return escaped
        .split(/\n{2,}/)
        .map((para) => {
            const withBreaks = para.replace(/\n/g, "<br />");
            return `<p>${inlineFormat(withBreaks)}</p>`;
        })
        .join("");
}
